import { Component, Vue, Prop } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './RegulationsManagement.html';
import { Toaster } from '../../Services/toast';
import RegulationsManagementService from './RegulationsManagementService';
import { RegulationRowModel } from './RegulationRowModel';
import UserService from '../../shared/userService/UserService';
import UserRoleService from '../../shared/userService/UserRoleService';

interface CategoryFilterItem {
    id: number;
    name: string;
}

@WithRender
@Component({
    diProvide: [RegulationsManagementService, UserService, UserRoleService],
})
export default class RegulationsManagement extends Vue {
    @Inject(RegulationsManagementService) public regulationsService!: RegulationsManagementService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;

    @Prop({ type: Boolean, default: false })
    public layoutSup!: boolean;

    public deleteDialog: boolean = false;
    public regulationIdToDelete: string = '';
    public loading: boolean = false;
    public regulations: RegulationRowModel[] = [];
    public filterCategory: number | null = 0;
    public categoryFilterList: CategoryFilterItem[] = [];

    public headers: any[] = [];

    public created() {
        this.categoryFilterList = [
            { id: 0, name: this.$t('shared.regulationAllCategories').toString() },
            { id: 1, name: this.$t('shared.regulationCategorySmsTemplate').toString() },
            { id: 2, name: this.$t('shared.regulationCategorySenderName').toString() },
        ];
        this.headers = [
            { text: this.$t('shared.regulationCategory').toString(), value: 'category', align: 'center', sortable: false },
            { text: this.$t('shared.regulationStatus').toString(), value: 'status', align: 'center', sortable: false },
            { text: this.$t('shared.regulationPolicies').toString(), value: 'regulations', align: 'center', sortable: false },
            { text: this.$t('shared.regulationAiPrompt').toString(), value: 'aiPrompt', align: 'center', sortable: false },
            { text: this.$t('shared.actions').toString(), value: 'id', align: 'center', sortable: false, width: '120' },
        ];
    }

    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        await this.load();
    }

    public async resetFilter() {
        this.filterCategory = 0;
        await this.load();
    }

    public async load() {
        this.loading = true;
        const fc = this.filterCategory;
        const cat = fc === null || fc === undefined || fc === 0 ? null : fc;
        const response = await this.regulationsService.getList(cat);
        this.loading = false;
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage || this.$t('shared.regulationLoadFailed').toString());
            this.regulations = [];
            return;
        }
        const list = (response.result || []) as any[];
        this.regulations = list.map((r) => ({
            id: r.id,
            regulations: r.regulations || '',
            aiPrompt: r.aiPrompt || '',
            category: r.category,
            status: r.status,
        }));
    }

    public categoryLabel(cat: number): string {
        if (cat === 1) {
            return this.$t('shared.regulationCategorySmsTemplate').toString();
        }
        if (cat === 2) {
            return this.$t('shared.regulationCategorySenderName').toString();
        }
        return String(cat);
    }

    public statusLabel(st: number): string {
        if (st === 0) {
            return this.$t('shared.regulationStatusDraft').toString();
        }
        if (st === 1) {
            return this.$t('shared.regulationStatusActive').toString();
        }
        return String(st);
    }

    public statusClass(st: number): string {
        return st === 1 ? 'badge badge-success' : 'badge badge-secondary';
    }

    public showDeleteDialog(id: string) {
        this.regulationIdToDelete = id;
        this.deleteDialog = true;
    }

    public hideDeleteDialog() {
        this.deleteDialog = false;
    }

    public async confirmDelete() {
        const response = await this.regulationsService.remove(this.regulationIdToDelete);
        if (response.isSuccess) {
            Toaster.success(this.$t('shared.deleteSuccessfully').toString());
            await this.load();
        } else {
            Toaster.error(response.errorMessage || this.$t('shared.regulationDeleteFailed').toString());
        }
        this.deleteDialog = false;
    }
}
